module.exports = __webpack_public_path__ + "static/media/cc_sdk.a5d003d4.md";